{
  "dashboard": {
    "welcome": "Welcome back, {{name}}",
    "welcomeSubtitle": "Here is your current competition and work status."
  },
  "judgeInvitations": {
    "title": "Judge invitations waiting for your answer",
    "description": "An organizer invited you to judge. After you accept, the submissions assigned to you appear in your judging assignments; if you cannot serve, you can decline.",
    "expires": "Reply by {{date}}",
    "accept": "Accept invitation",
    "decline": "Decline",
    "reasonLabel": "Reason for declining (optional)",
    "confirmDecline": "Confirm decline",
    "cancel": "Cancel",
    "accepted": "Invitation accepted. You are now a judge of this competition.",
    "goToJudging": "Go to judging assignments",
    "declined": "Invitation declined. The organizer can see this in the admin area.",
    "error": "That did not work. The invitation may have expired; reload and try again."
  },
  "nextActions": {
    "title": "My next steps",
    "priority": {
      "p0": "Overdue",
      "p1": "Due soon",
      "p2": "To do"
    },
    "item": {
      "adminPublish": "Finish setup and publish",
      "judgePending_one": "{{count}} judging task pending",
      "judgePending_other": "{{count}} judging tasks pending",
      "platformGovernance_one": "{{count}} competition request awaiting review",
      "platformGovernance_other": "{{count}} competition requests awaiting review",
      "studentRegistration": "Complete your registration",
      "studentRegistrationUpdate": "Complete your registration (a required field is still missing)",
      "studentTeam": "Create or join a team",
      "studentSubmission": "Finish your submission"
    },
    "cta": {
      "adminPublish": "Manage competition →",
      "judgePending": "Go to judging →",
      "platformGovernance": "Review now →",
      "studentRegistration": "Continue registration →",
      "studentRegistrationUpdate": "Update registration →",
      "studentTeam": "Manage team →",
      "studentSubmission": "Continue submission →"
    },
    "deadline": "Due: {{date}}",
    "empty": {
      "title": "Nothing needs your attention right now",
      "description": "Explore new competitions, or check the ones you're already part of.",
      "exploreCta": "Explore competitions"
    }
  },
  "workspaces": {
    "title": "My workspaces",
    "participate": {
      "title": "Participating",
      "count_one": "{{count}} in progress",
      "count_other": "{{count}} in progress",
      "cta": "Continue participating →"
    },
    "manage": {
      "title": "Competition management",
      "count_one": "{{count}} managed",
      "count_other": "{{count}} managed",
      "cta": "Manage competitions →"
    },
    "judge": {
      "title": "Judging",
      "count_one": "{{count}} judging task",
      "count_other": "{{count}} judging tasks",
      "cta": "Go to judging →"
    },
    "platform": {
      "title": "Platform governance",
      "count_one": "{{count}} item needs attention",
      "count_other": "{{count}} items need attention",
      "cta": "Manage platform →"
    }
  },
  "recent": {
    "title": "Recently used competitions",
    "empty": "You have not taken part in any competition yet.",
    "nextDeadline": "Next deadline"
  },
  "discoveryPreview": {
    "title": "Explore competitions",
    "exploreAll": "Explore all competitions →",
    "viewDetails": "View competition →"
  },
  "hero": {
    "liveBadge_one": "{{count}} competition open now",
    "liveBadge_other": "{{count}} competitions open now",
    "title": "Run sharper competitions. Let the work stand out.",
    "subtitle": "NAPAICP brings registration, judging, and final selection together in one platform for fair and auditable competition management.",
    "description": "NAPAICP (NAPAI Competition Platform) delivers a complete experience for team management, submissions, judging, and result publishing, bringing greater transparency and trust to every competition.",
    "primaryCta": "Sign in",
    "secondaryCta": "See how it works"
  },
  "publishedCompetitions": {
    "heading": "Competitions open right now",
    "description": "A live view of every competition currently public on the platform; no sign-in required.",
    "empty": "No competitions are public right now. Once one opens, it will show up here.",
    "nextDate": "Next date: {{date}}",
    "viewDetails": "View competition →",
    "filters": {
      "searchPlaceholder": "Search by name or summary",
      "statusLabel": "Status",
      "statusAny": "Any status",
      "participationLabel": "Participation",
      "participationAny": "Individual or team",
      "categoryLabel": "Category",
      "categoryAny": "All categories",
      "individual": "Individual",
      "team": "Team",
      "sortLabel": "Sort",
      "sortNewest": "Newest",
      "sortDeadline": "By deadline",
      "closingSoon": "Closing soon (within 7 days)",
      "noMatches": "No competitions match these filters; try adjusting your search or filters.",
      "previousPage": "Previous",
      "nextPage": "Next",
      "pageOf": "Page {{page}} of {{totalPages}}"
    }
  },
  "roles": {
    "heading": "Choose your role to get started",
    "student": {
      "title": "Student",
      "description": "Join a team, fill out competition forms, submit your work, and track its status and results.",
      "cta": "Go to the student area"
    },
    "judge": {
      "title": "Judge",
      "description": "Review your assignments, score against the rubric, and submit your scores.",
      "cta": "Go to the judge area"
    },
    "admin": {
      "title": "Administrator",
      "description": "Create and manage competitions, teams and submissions, rubrics, judge assignments, and results.",
      "cta": "Go to the admin area"
    }
  },
  "features": {
    "heading": "Platform features",
    "multiCompetition": {
      "title": "Multi-competition isolation",
      "description": "Each competition manages its own teams, submissions, and permissions independently."
    },
    "dynamicForms": {
      "title": "Dynamic registration & submission forms",
      "description": "Customize registration and submission fields per competition, versioned as they're published."
    },
    "fileVersioning": {
      "title": "Private file uploads with versioning",
      "description": "Submission files upload privately and keep a version history you can trace back."
    },
    "rubricJudging": {
      "title": "Rubric-based judging",
      "description": "Judges score against a standardized rubric, with transparent, consistent assignments."
    },
    "lifecycle": {
      "title": "Competition lifecycle management",
      "description": "Registration, submission, judging, and results: every stage has a clear, controlled status."
    },
    "resultsAudit": {
      "title": "Results & audit trail",
      "description": "Result calculation, locking, and publishing are all recorded for later review."
    }
  },
  "coreMoat": {
    "heading": "Why it can be trusted",
    "description": "Real behaviors of the NAPAICP Competition Platform; every one of them can be verified.",
    "items": {
      "integrity": {
        "title": "Integrity",
        "description": "Once a submission is finalized, its original content and submission time are preserved; never silently overwritten."
      },
      "fairness": {
        "title": "Fairness",
        "description": "Judge-facing APIs never return participant identity fields that should stay hidden, and reported conflicts of interest trigger recusal."
      },
      "governance": {
        "title": "Governance",
        "description": "Every authorization decision runs on the server, scoped by competition and role; hiding a button in the UI is never the security boundary."
      },
      "auditability": {
        "title": "Auditability",
        "description": "Changes to scores, permissions, and other sensitive state keep a record of who acted, when, and why."
      },
      "isolation": {
        "title": "Isolation",
        "description": "Submissions, teams, and roles from one competition never leak into another; each competition is its own boundary."
      }
    }
  },
  "learnMore": {
    "heading": "Want to learn more?"
  },
  "trust": {
    "heading": "Platform Development Team",
    "intro": "NAPAICP (NAPAI Competition Platform) is developed in partnership by the NAPAI Program and the NTPU AI4X Research Center",
    "sponsorHeading": "Sponsoring unit",
    "partnersHeading": "Partner institutions",
    "teamHeading": "NAPAI program team",
    "visitProgram": "NAPAI Program",
    "visitCenter": "NTPU AI4X Research Center",
    "visitPerson": "Visit {{name}}'s homepage",
    "roles": {
      "pi": "Principal Investigator",
      "coPi": "Co-Principal Investigator"
    },
    "members": {
      "chchang": {
        "name": "Prof. Chia-Hui Chang",
        "affiliation": "Department of Computer Science and Information Engineering, National Central University"
      },
      "myday": {
        "name": "Prof. Min-Yuh Day",
        "affiliation": "Graduate Institute of Information Management, National Taipei University"
      },
      "mchu": {
        "name": "Prof. Min-Chun Hu",
        "affiliation": "Department of Computer Science, National Tsing Hua University"
      }
    }
  }
}
